import { writable } from 'svelte/store';
export const currentSegmentIdx = writable(0);
export const currentFrameDetection = writable(undefined);
export const selectedTrackId = writable(null);
export const selectedVerticalLine = writable(null);
